import { render } from "./SwitchDateInput.vue?vue&type=template&id=393df874&scoped=true"
import script from "./SwitchDateInput.vue?vue&type=script&lang=js"
export * from "./SwitchDateInput.vue?vue&type=script&lang=js"

import "./SwitchDateInput.vue?vue&type=style&index=0&id=393df874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393df874"]])

export default __exports__